import { render } from "./SurveyResponses.vue?vue&type=template&id=5b5068fa&scoped=true"
import script from "./SurveyResponses.vue?vue&type=script&lang=js"
export * from "./SurveyResponses.vue?vue&type=script&lang=js"

import "./SurveyResponses.vue?vue&type=style&index=0&id=5b5068fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5068fa"]])

export default __exports__